import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { GET_USER_PROFILE } from 'src/app/common/graphql/queries';
import { CommonserviceService } from 'src/app/common/services/commonservice.service';
import { SpinnerService } from 'src/app/common/services/spinner.service';
import { ErrorHandlerService } from 'src/app/common/services/error-handler.service';
import { viewUserProfile } from 'src/app/common/models/viewUserProfile.model';
import { DecodedSSOToken } from 'src/app/common/models/decodedSsoToken';
import { userApplConfigSignal, userDetailsSignal } from 'src/app/common/signals/user-profile-signal';
 
@Component({
  selector: 'app-view-profile',
  templateUrl: './view-profile.component.html',
  styleUrls: ['./view-profile.component.css']
})
export class ViewProfileComponent {
  user : viewUserProfile = {namc: '', shop: '', plant: '', line: ''};
  userDetails: DecodedSSOToken;
  namc: string = '';
  role: string = '';
  firstName: string = '';
  isLoading: boolean = false;
  constructor(private readonly router: Router, 
    private readonly commonService: CommonserviceService,
    private readonly spinner: SpinnerService,
    private readonly errorService: ErrorHandlerService
  ){

  }
  ngOnInit(): void {
    this.errorService.clearErrorMessage();
    this.spinner.show();
    const userDetailsString = sessionStorage.getItem('ssoUserDetails');
    if (userDetailsString) {
      this.userDetails = JSON.parse(userDetailsString) as DecodedSSOToken;
      this.getNamcName();
      this.getRoles();
    }
    const userId = userDetailsSignal().userId;
    this.commonService.getHcmData(GET_USER_PROFILE, {userId}).subscribe({
      next: (response) => {
        if(response?.data?.getUserProfile?.userProfile){
          this.user.plant = response?.data?.getUserProfile?.userProfile?.plantName;
          this.user.shop = response?.data?.getUserProfile?.userProfile?.shopName;
          this.user.line = response?.data?.getUserProfile?.userProfile?.lineName;
          userApplConfigSignal.update(currentValue => ({ ...currentValue, ...response?.data?.getUserProfile?.userProfile }));
        } 
        if(response?.data?.getUserProfile?.userWorkDay) {
          this.firstName = response?.data?.getUserProfile?.userWorkDay?.firstName;
        }
        else {
          this.spinner.hide();
          this.errorService.setErrorMessage([]);        
        }
        if(response?.errors){
          this.spinner.hide();
          this.errorService.setErrorMessage([]);
        }
      },
      error: (error) => {
        this.spinner.hide();
        this.errorService.setErrorMessage([]);
      },
      complete: () => {
        this.spinner.hide();
      }
    });
  }
  public navigateToEditProfile():void{
    this.router.navigate(['/edit-profile']);
  }

  public navigateToHome():void{
    this.router.navigate(['home']);
  }

  private getNamcName(): void {
    this.commonService.getNamc().subscribe({
      next: (response) => {
        this.namc = response;
      },
      error: (error) => {
        console.error('getNacm Error:', error);
      }
    });
  }

  private getRoles(): void {
    this.commonService.getRoles().subscribe({
      next: (response) => {
        this.role = response;
      },
      error: (error) => {
        console.error('getRoles Error:', error);
      }
    });
  }
}